import { inject, Service } from '@angular/core';

import { SessionService } from '@advania-cosoftware/wolf-core';

export const itClimateSegments = {
    itClimate: 'it-climate',
} as const;

const itClimateRoutes = {
    base: [itClimateSegments.itClimate],
};

@Service()
export class ItClimateRouter {
    private readonly _sessionService = inject(SessionService);

    public getItClimateRoute(): string[] {
        return ['/', this._sessionService.activeCustomerNumber(), ...itClimateRoutes.base];
    }
}
